import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-y: auto;
  padding: 16px;
  width: 100%;
  min-height: 100vh;

  > div div {
    width: 60px;
    height: 60px;
  }
`

export const HpxContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;

  > div {
    width: 60px;
    height: 60px;
  }
`
